import { useCallback, useRef, useState } from "react";
import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { CircularProgress, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { RecordNotFound } from "../../components/_dashboard/programmes";
import { vidoe_librar_detail_api } from "../../DAL/Programmes/Programmes";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VideoLibraryCard from "./VideoLibraryCard";
import CustomDrawer from "src/components/GeneralComponents/CustomDrawer";
import VideoFilter from "./VideoFilter";
import { bms_date_format } from "src/utils/constants";
import FilteredChipNew from "src/components/FilteredChipNew";
import { Icon } from "@iconify/react";
import roundFilterList from "@iconify/icons-ic/round-filter-list";
import moment from "moment";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function VidoeLibraryDetail() {
  const params = useParams();
  const observer = useRef();
  const classes = useStyles();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [programmesData, setProgrammesData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const { state } = useLocation();
  const load_more_path = `api/member/videos_library?page=0&limit=50`;

  const [filterDrawerState, setFilterDrawerState] = useState(false);
  const getTodayDate = () => {
    const today = new Date();
    return today;
  };

  const getOneMonthAgoDate = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date;
  };

  const EMPTY_FILTER = {
    start: getOneMonthAgoDate(),
    end: getTodayDate(),
  };

  const handleSelectOther = (name, value) => {
    setFilterData((values) => ({ ...values, [name]: value }));
  };

  const [filterData, setFilterData] = useState(EMPTY_FILTER);
  const [updateFilterData, setUpdateFilterData] = useState(EMPTY_FILTER);

  const handleOpenFilterDrawer = () => {
    setFilterDrawerState(true);
  };

  const handleCloseFilterDrawer = () => {
    setFilterDrawerState(false);
  };

  const getProgrammesList = async (path, loading, filterData) => {
    if (!loading) {
      setIsLoading(true);
      path = load_more_path;
    }

    let postData = { ...filterData };
    if (postData.start) {
      postData.start = moment(postData.start).format("YYYY-MM-DD");
    }
    if (postData.end) {
      postData.end = moment(postData.end).format("YYYY-MM-DD");
    }
    handleCloseFilterDrawer();

    const result = await vidoe_librar_detail_api(
      path,
      params.library_id,
      postData.start,
      postData.end,
    );
    if (result.code === 200) {
      setLoadMorePath(result?.meta?.load_more);
      setTotalPages(result?.meta?.totalPages);
      if (loading) {
        let new_array = programmesData.concat(result.video_library);
        setProgrammesData(new_array);
        setPageNumber((prev) => prev + 1);
      } else {
        setProgrammesData(result.video_library);
        setPageNumber(1);
      }
      let chipData = { ...filterData };

      if (chipData.start && chipData.end) {
        let date = `Start Date : ${bms_date_format(
          chipData.start,
        )} End Date :  ${bms_date_format(chipData.end)}`;
        chipData.date = {
          chip_label: date,
          chip_value: date,
        };
        delete chipData.start;
        delete chipData.end;
      }

      setUpdateFilterData(chipData);
      setIsLoading(false);
      setIsLoadingMore(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
      setIsLoadingMore(false);
    }
  };

  const searchFunction = () => {
    if (!filterData.start && !filterData.end) {
      enqueueSnackbar("Please select date", { variant: "error" });
      return;
    }
    if (filterData.start && filterData.end) {
      getProgrammesList(loadMorePath, false, filterData);
    }
  };

  const handleClearFilter = () => {
    getProgrammesList(loadMorePath, false, EMPTY_FILTER);
    setFilterData(EMPTY_FILTER);
    setUpdateFilterData(EMPTY_FILTER);
  };

  const handleDeleteChip = () => {
    getProgrammesList(loadMorePath, false, EMPTY_FILTER);
    setUpdateFilterData(EMPTY_FILTER);
    setFilterData(EMPTY_FILTER);
  };

  const loadMoreData = () => {
    setIsLoadingMore(true);
    getProgrammesList(loadMorePath, true, filterData);
  };

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages >= pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, loadMorePath, observer],
  );

  useEffect(() => {
    getProgrammesList(load_more_path, false, filterData);
  }, []);

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <IconButton
              className="back-screen-button ms-2"
              onClick={() => {
                navigate(-1);
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            <h2>{state?.title ? state?.title : "Videos Library Detail"} </h2>
          </div>
          <button
            className="small-contained-button me-2 mt-1 mb-4"
            onClick={handleOpenFilterDrawer}
          >
            Filters &nbsp;&nbsp; <Icon icon={roundFilterList} />
          </button>
        </div>
        <div className="my-3">
          <FilteredChipNew
            data={updateFilterData}
            tempState={filterData}
            EMPTY_FILTER={EMPTY_FILTER}
            onDeleteChip={handleDeleteChip}
            onClear={handleClearFilter}
          />
        </div>
        {programmesData && programmesData.length > 0 ? (
          <>
            <VideoLibraryCard videos={programmesData} />
          </>
        ) : (
          <>
            <RecordNotFound title="videos" />
          </>
        )}
        {totalPages >= pageNumber ? (
          <div className="text-center mt-3">
            <span
              ref={lastBookElementRef}
              className="mt-3"
              onClick={loadMoreData}
              id="load-more-feed"
            >
              {isLoadingMore ? (
                <CircularProgress color="primary" size="1.5rem" />
              ) : (
                "Load More"
              )}
            </span>
          </div>
        ) : (
          ""
        )}
      </div>
      <CustomDrawer
        isOpenDrawer={filterDrawerState}
        onOpenDrawer={handleOpenFilterDrawer}
        onCloseDrawer={handleCloseFilterDrawer}
        pageTitle="Filters"
        componentToPassDown={
          <VideoFilter
            filterData={filterData}
            handleSelectOther={handleSelectOther}
            searchFunction={searchFunction}
            handleClearFilter={handleClearFilter}
          />
        }
      />
    </div>
  );
}
